import React from 'react';
import Header from "../lib/Header";
import Input from "./Input";
import Preview from "./Preview";
import GoldColorSelector from "../lib/GoldColorSelector";
import OrientationSelector from "./OrientationSelector";

export default class App extends React.Component {
    render() {
        return (
            <div className="product__options customizer">
                <div className="customizer__heroine">
                    <Preview/>
                </div>
                <div>
                    <Header text='Custom Letter Charm'/>
                    <OrientationSelector/>
                    <GoldColorSelector/>
                    <Input/>
                </div>
            </div>
        );
    }
}
